import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import Icon from 'components/DesignSystem/Icon';
import { Charts } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';
import { cssVar } from 'constants/theme';

import buildMobileChartOption from '../chartOption';

import './index.scss';

export default function FullscreenChart({
  open,
  dismiss,
  title,
  option,
  zoomStart,
  zoomEnd,
}: {
  open: boolean;
  dismiss: () => void;
  title?: string;
  option?: Charts;
  zoomStart: number;
  zoomEnd: number;
}) {
  if (!open || !option) return null;

  // Em paisagem sobra largura, então a legenda cabe numa faixa menor no topo.
  const echartsOption = buildMobileChartOption(option, zoomStart, zoomEnd, 40);

  return (
    <div className="agro-ci-location-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="agro-ci-location-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="agro-ci-location-fullscreen-rotate">
        <div className="agro-ci-location-fullscreen-chart">
          <div className="agro-ci-location-fullscreen-chart-header">
            <span className="agro-ci-location-fullscreen-chart-title">{title}</span>
          </div>
          <div className="agro-ci-location-fullscreen-chart-body">
            <ReactECharts
              className="h-100"
              style={{ height: '100%' }}
              option={echartsOption}
            />
          </div>
        </div>
      </div>
      <span className="agro-ci-location-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
